export default __webpack_public_path__ + "static/media/t4.ddbc5f9e.jpeg";